import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button, Modal } from "@similarweb/ui-components";

import { contactUsModalConfig } from "app/pages/sales-intelligence/common-components/ContactUsModal/configs";
import ModalContent from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/ModalContent";
import { useDynamicsEnrichmentInterest } from "app/pages/sales-intelligence/modules/manage-integrations/hooks/useDynamicsEnrichmentInterest";
import { featureHookKeys } from "app/pages/sales-intelligence/utils/i18n/feature-hook";

const StyledInterestedButton = styled(Button)<{ $isFullWidth?: boolean }>`
    width: ${({ $isFullWidth }) => ($isFullWidth ? "100%" : "auto")};
`;

interface IProps {
    dataAutomation?: string;
    isFullWidth?: boolean;
}

export const DynamicsEnrichmentInterestedButton = ({
    dataAutomation = "dynamics-enrichment-interested-button",
    isFullWidth = false,
}: IProps): React.ReactElement => {
    const { translate } = useTranslate();
    const { isSubmitted, isThanksModalOpen, handleInterestedClick, handleCloseThanksModal } =
        useDynamicsEnrichmentInterest();

    return (
        <>
            <StyledInterestedButton
                buttonHtmlType="button"
                type="flat"
                onClick={handleInterestedClick}
                isDisabled={isSubmitted}
                data-automation={dataAutomation}
                $isFullWidth={isFullWidth}
            >
                {translate(featureHookKeys.userInterestedCta)}
            </StyledInterestedButton>
            <Modal
                isOpen={isThanksModalOpen}
                customStyles={contactUsModalConfig}
                onRequestClose={handleCloseThanksModal}
            >
                <Modal.CloseButton onClick={handleCloseThanksModal} />
                <ModalContent
                    title={translate(featureHookKeys.modalSuccessTitle)}
                    subTitle={translate(featureHookKeys.modalSuccessSubtitle)}
                    onClick={handleCloseThanksModal}
                />
            </Modal>
        </>
    );
};
